<template>
	<el-drawer :title="formData.id ? '编辑渠道' : '新增渠道' " :visible.sync="drawerShow" :wrapperClosable="false"
		:destroy-on-close="true" size="85%" @close="close">
		<div class="drawer-content">
			<el-form :model="formData" :rules="rules" ref="formData" label-position="top" size="medium">
				<el-form-item prop="status" label="状态:">
					<el-radio-group v-model="formData.status">
						<el-radio :label="1">启用</el-radio>
						<el-radio :label="0">禁用</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="thirdName" label="渠道名称:">
					<el-input v-model="formData.thirdName" placeholder="请填写渠道名称" :maxlength="20"></el-input>
				</el-form-item>
				<el-form-item prop="source" label="Source:">
					<el-input v-model="formData.source" placeholder="请填写Source" :maxlength="40"></el-input>
				</el-form-item>
				<el-form-item prop="orderPrefix" label="订单前缀:">
					<el-input v-model="formData.orderPrefix" placeholder="请填写订单前缀" :maxlength="4"></el-input>
				</el-form-item>
				<el-form-item prop="isSettlement" label="是否涉及结算:">
					<el-radio-group v-model="formData.isSettlement">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="suduSelectable" label="经营平台是否可选:">
					<el-radio-group v-model="formData.suduSelectable">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<!-- 可访问路径：该渠道允许访问的接口/页面路径，一行一个 -->
				<el-form-item prop="privilege" label="可访问路径:">
					<el-input
						v-model="formData.privilege"
						type="textarea"
						:autosize="{ minRows: 3 }"
						placeholder="请填写可访问路径，一行一个路径"
					></el-input>
				</el-form-item>
				<el-card>
					<el-form-item>
						<span slot="label">默认服务费设置：<el-button icon="el-icon-plus" size="mini" type="primary"
								@click="addRule()">添加规则</el-button></span>
						<div class="MB20"  style="overflow: auto;">
							<table ref="table" border="0" class="draggable-table">
								<thead>
									<tr v-if="rulesList.length >0 ">
									<th>
									    <div class="cell">排序</div>
									</th>
										<th><div class="cell">活动类型</div></th>
										<th><div class="cell">服务费比例</div></th>
										<th><div class="cell">操作</div></th>
									</tr>
								</thead>
								<vuedraggable v-model="rulesList" tag="tbody" handle=".handle">
									<template v-if="rulesList && rulesList.length > 0">
										<tr v-for="(item, index) in rulesList" :key="index">
											<td>
											    <div class="cell handle">                                
											        <i class="el-icon-sort"></i>
											    </div>
											</td>
											<td>
												 <div class="cell">
												<el-cascader v-model="item.styleType" :options="showTypeTagList"
													:props="{ checkStrictly: true, value: 'id', label: 'name', children: 'tags', emitPath:false }"
													clearable size="small" placeholder="不限制活动类型" style="width:100%"
													:ref="`cascader${index}`" @change="handleChange(index)">
												</el-cascader>
												</div>
											</td>
											<td>
												 <div class="cell">
												<el-input-number style="width:80%" v-model="item.rulesServiceFee"
													controls-position="right" :precision="2"
													:max="100"></el-input-number> %</div>
											</td>
											<td>
												<div class="cell"> 
												<el-button type="primary" plain size="small"
													@click="rulesList.splice(index, 1)">删除</el-button></div>
											</td>
										</tr>
									</template>
								</vuedraggable>
							</table>
						</div>
						<el-form-item prop="serviceFee" label="默认服务费比例:(除以上规则外,其余演出类型都按这个默认比例处理)"
							v-if="formData.isSettlement == 1">
							<el-input-number style="width:80%" v-model="formData.serviceFee" controls-position="right"
								:precision="2" placeholder="请输入默认比例" :max="100"></el-input-number> %
						</el-form-item>
					</el-form-item>
				</el-card>
				<el-form-item prop="status" label="是否推送多人票:">
					<el-radio-group v-model="formData.isPushMultiMemberTicket" disabled="disabled">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
				<el-form-item prop="status" label="是否推送通票:">
					<el-radio-group v-model="formData.isPushThroughTicket" disabled="disabled">
						<el-radio :label="1">是</el-radio>
						<el-radio :label="0">否</el-radio>
					</el-radio-group>
				</el-form-item>
			</el-form>
		</div>
		<div class="drawer-footer">
			<el-button @click="close">取消</el-button>
			<el-button type="primary" @click="submitForm()" :loading="btnLoading">确 定</el-button>
		</div>
	</el-drawer>
</template>

<script>	
	import vuedraggable from 'vuedraggable';
	const defaultFormData = {
		orderPrefix: "",
		source: "",
		status: 1,
		thirdName: "",
		isPushMultiMemberTicket: 0,
		isPushThroughTicket: 0,
		suduSelectable:0,
		privilege: "" //可访问路径，多个用英文逗号分隔
	}
	export default {
		components: {vuedraggable},
		data() {
			return {
				drawerShow: false,
				btnLoading: false,
				formData: {
					...defaultFormData
				},
				rulesList: [{
					styleType: [],
					rulesServiceFee: ''
				}],
				showTypeTagList: [],
				styleType: [],
				rulesServiceFee: '',
				cascader: null,
				rules: {
					thirdName: [{
						required: true,
						message: "请填写渠道名称"
					}],
					source: [{
						required: true,
						message: "请填写Source"
					}],
					orderPrefix: [{
						required: true,
						message: "请填写订单前缀"
					}],
					isSettlement: [{
						required: true,
						message: "请选择是否涉及结算"
					}],
					//可访问路径必填，按换行拆分校验每行非空
					privilege: [{
						required: true,
						message: "请填写可访问路径"
					}, {
						validator: (rule, value, callback) => {
							//按换行拆分，过滤空行后校验每行是否有内容
							const lines = String(value || '').split('\n').map(v => v.trim()).filter(v => v);
							if (!lines.length) {
								callback(new Error('请填写可访问路径'));
							} else if (lines.length !== String(value || '').split('\n').filter(v => v.trim()).length) {
								callback(new Error('路径不能为空行'));
							} else {
								callback();
							}
						}
					}],
				},
			}
		},
		created() {
			this.getShowTypeTag()
		},
		methods: {
			show(data) {
				this.formData = {
					...defaultFormData,
					...data,
				}
				this.drawerShow = true;
				
				// if (data.serviceFeeMap) {
				// 	const array = []
				// 	var styleType = ''
				// 	for (const id in data.serviceFeeMap) {
				// 		this.showTypeTagList.forEach(item => {
				// 			if (item.id === parseInt(id)) {
				// 				styleType = [(parseInt(id))]
				// 			} else {
				// 				if (item.tags && item.tags.length > 0) {
				// 					item.tags.forEach(items => {
				// 						if (items.id === parseInt(id)) {
				// 							styleType = [item.id, parseInt(id)]
				// 						}
				// 					})
				// 				}
				// 			}
				// 		})
				// 		array.push({
				// 			styleType: styleType,
				// 			rulesServiceFee: data.serviceFeeMap[id],
				// 		})
				// 	}
				// 	this.rulesList = array

				// }
				if (data.serviceFeeMap && data.serviceFeeMap.length > 0 ) {
					const array = []
					var styleType = ''
					data.serviceFeeMap.forEach(item => {
						this.showTypeTagList.forEach(items => {
							
							if (parseInt(item.key) === items.id ) {
								styleType = [parseInt(item.key)]
							}else{
								if (items.tags && items.tags.length > 0) {
									items.tags.forEach(its => {
										if (its.id === parseInt(item.key) ) {
											styleType = [items.id, parseInt(item.key)]
										}
									})
								}
							}
						})
						array.push({
							styleType: styleType,
							rulesServiceFee: item.value,
						})
					})
					this.rulesList = array
					console.log(this.rulesList)
				}
				
			},
			close() {
				this.formData = {
					...defaultFormData
				};
				this.$refs.formData.resetFields();
				this.drawerShow = false;
				this.rulesList = []
			},
			//获取活动类型
			getShowTypeTag() {
				this.$request({
					url: "/styleTag/showType/all",
					method: "post",
					params: {
						isAll: 1
					}
				}).then(res => {
					const {
						state,
						result
					} = res.data;
					if (state == 1) {
						this.showTypeTagList = result || []
					}
				})
			},
			handleChange(index) {
				// 通过动态 ref 名称访问
				const cascaderRefName = `cascader${index}`;
				const cascader = this.$refs[cascaderRefName];

				if (cascader && cascader[0]) {
					var item = cascader[0].getCheckedNodes()[0].path
					this.rulesList.forEach((itm, idx) => {
						if (index === idx) {
							this.rulesList[index].styleType = item
						}
					});
				}
			},

			addRule() {
				this.rulesList.push({
					styleType: [],
					rulesServiceFee: ''
				})
			},
			
			submitForm() {
				console.log(this.rulesList)
				
				const _serviceFeeMap = [];
				
				if (this.rulesList && this.rulesList.length) {
				  this.rulesList.forEach(item => {
				    if (Array.isArray(item.styleType) && item.styleType.length) {
				      const index = item.styleType.length > 1 ? 1 : 0;
				      const rawKey = item.styleType[index];
				      
				      if (rawKey != null) {
				        _serviceFeeMap.push({
				          key: String(rawKey),
				          value: item.rulesServiceFee
				        });
				      }
				    }
				  });
				}
				
				console.log(_serviceFeeMap)
				//return
				this.$refs["formData"].validate(async (valid) => {
					if (valid) {
						this.btnLoading = true;
						//可访问路径按换行拆分后去除空行，再以换行拼接提交
						const privilegeLines = String(this.formData.privilege || '').split('\n').map(v => v.trim()).filter(v => v);
						this.$request({
								url: '/thirdAccountManage/saveOrUpdate',
								data: {
									...this.formData,
									privilege: privilegeLines.join('\n'),
									serviceFeeMap:_serviceFeeMap
								},
								method: "post",
							})
							.then((res) => {
								const {
									state,
									msg
								} = res.data;
								if (state == 1) {
									this.$emit('onUpdate');
									this.close();
								} else {
									this.$message.error(msg || "操作失败,请重试");
								}
							})
							.catch(() => {
								this.$message.error("操作失败,请重试");
							})
							.finally(() => {
								this.btnLoading = false;
							});
					} else {
						return false;
					}
				});
			}
		}
	}
</script>
<style lang="scss" scoped>
.draggable-table {
    table-layout: auto;
    border-collapse: collapse;
    width: 100%;
    min-width: 710px;
    border: 1px solid #ebeef5;

    .empty {
        text-align: center;
        line-height: 20px;
        color: #909399;
    }

    th,
    td {
        position: relative;
        padding: 10px 0;
        text-align: left;
        border: 1px solid #ebeef5;
        border-top: 0;
        border-left: 0;
        vertical-align: middle;
        box-sizing: border-box;

        .cell {
            padding: 0 10px;
            width: 100%;
            white-space: normal;
            word-break: break-all;
            line-height: 23px;
            overflow: hidden;
            box-sizing: border-box;

            &.handle {
                cursor: move;
            }
        }
    }

    th {
        background-color: #f5f7fa;
        font-size: 13px;
        color: #909399;
        font-weight: 700;
        .cell{
            white-space: nowrap;
        }
    }

    td {
        font-size: 13px;
        color: #606266;
    }

    tr:hover td {
        background-color: #f5f7fa;
    }
}
</style>